import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import MenuItem from '../MenuItem'
import SubMenu from '../SubMenu'
import ItemGroup from '../ItemGroup'
import style from '../style.module.less'

@inject('menuStore')
@observer
export default class Menu extends Component {
  static Item = MenuItem
  static SubMenu = SubMenu
  static ItemGroup = ItemGroup

  render() {
    const {
      menuStore: {
        isSelecedKeyChildOfCurrentOpenKey,
        onMenuOpenChange,
        menuOffset
      }
    } = this.props
    return (
      <div
        className={style['menu-area']}
        style={{
          height: `calc(100% - ${menuOffset}px)`
        }}
      >
        <div
          className={style['menu-area-main']}
          onMouseLeave={() => {
            const {
              isChild,
              selectedKeyPath
            } = isSelecedKeyChildOfCurrentOpenKey()
            if (!isChild) {
              onMenuOpenChange(selectedKeyPath[0])
            }
          }}
        >
          {this.props.children}
        </div>
        {this.props.bottom}
      </div>
    )
  }
}
